export default __webpack_public_path__ + "static/media/022-linkedin.4b07ec4c.svg";